export default "__VITE_ASSET__XddGX7u7__"